import { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { Minus, Plus } from "lucide-react";
import { Overline, Reveal } from "./Reveal";

const FAQS = [
  {
    q: "Quanto tempo leva para meu site ficar pronto?",
    a: "Depende do escopo do projeto. Uma landing page tem um ciclo mais curto, enquanto um site institucional completo envolve estratégia, design e conteúdo. No diagnóstico inicial apresentamos um cronograma claro para o seu caso.",
  },
  {
    q: "Preciso investir muito em anúncios para começar?",
    a: "Não. A verba de anúncios é definida de acordo com a realidade do seu negócio e os objetivos da campanha. O mais importante é começar com estrutura correta: página preparada, público bem segmentado e mensuração configurada.",
  },
  {
    q: "O que é rastreamento de conversões e por que ele importa?",
    a: "É a mensuração do que acontece depois do clique: quem preencheu o formulário, quem clicou no WhatsApp, qual campanha gerou cada contato. Sem ele, você investe no escuro. Com ele, cada decisão passa a ser orientada por dados.",
  },
  {
    q: "A GOBAX promete um número garantido de clientes?",
    a: "Não — e desconfie de quem promete. O que entregamos é estrutura profissional: site estratégico, campanhas bem configuradas e dados confiáveis para evoluir continuamente. Resultados consistentes nascem de método, não de promessa.",
  },
  {
    q: "Vocês atendem o meu segmento?",
    a: "Nosso foco são negócios locais e empresas de serviços: clínicas, consultórios, studios, lojas e profissionais liberais. Cada estratégia é adaptada à realidade, ao público e aos objetivos do seu negócio.",
  },
  {
    q: "Como começamos?",
    a: "Pelo WhatsApp. Você conta o que deseja alcançar, fazemos o diagnóstico da sua presença digital e apresentamos o caminho recomendado — sem compromisso.",
  },
];

export const FAQ = () => {
  const [open, setOpen] = useState(0);

  return (
    <section id="faq" data-testid="faq-section" className="relative py-24 lg:py-32">
      <div className="mx-auto max-w-4xl px-4 sm:px-6 lg:px-12">
        <Reveal className="text-center">
          <Overline className="inline-flex items-center">Dúvidas frequentes</Overline>
          <h2 className="mt-6 font-display text-2xl font-bold leading-tight tracking-tight sm:text-3xl lg:text-4xl">
            Perguntas que ouvimos <span className="chrome-text">antes de cada projeto</span>
          </h2>
        </Reveal>

        <div className="mt-14 divide-y divide-white/8 border-y border-white/8">
          {FAQS.map((item, i) => {
            const isOpen = open === i;
            return (
              <Reveal key={item.q} delay={0.05 * i}>
                <div data-testid={`faq-item-${i}`}>
                  <button
                    type="button"
                    onClick={() => setOpen(isOpen ? -1 : i)}
                    aria-expanded={isOpen}
                    data-testid={`faq-toggle-${i}`}
                    className="group flex w-full items-center justify-between gap-6 py-6 text-left"
                  >
                    <span className={`font-display text-base font-bold transition-colors duration-300 sm:text-lg ${isOpen ? "text-gb-silverhi" : "text-gb-white group-hover:text-gb-silverhi"}`}>
                      {item.q}
                    </span>
                    <span className={`flex h-9 w-9 shrink-0 items-center justify-center rounded-full border transition-all duration-300 ${isOpen ? "border-gb-silver/60 bg-gb-silver/10 text-gb-silverhi" : "border-white/15 text-gb-gray group-hover:border-gb-silver/40"}`}>
                      {isOpen ? <Minus className="h-4 w-4" aria-hidden="true" /> : <Plus className="h-4 w-4" aria-hidden="true" />}
                    </span>
                  </button>
                  <AnimatePresence initial={false}>
                    {isOpen && (
                      <motion.div
                        initial={{ height: 0, opacity: 0 }}
                        animate={{ height: "auto", opacity: 1 }}
                        exit={{ height: 0, opacity: 0 }}
                        transition={{ duration: 0.45, ease: [0.16, 1, 0.3, 1] }}
                        className="overflow-hidden"
                      >
                        <p data-testid={`faq-answer-${i}`} className="max-w-2xl pb-7 text-sm leading-relaxed text-gb-gray sm:text-base">
                          {item.a}
                        </p>
                      </motion.div>
                    )}
                  </AnimatePresence>
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
};
